













import { Component, Prop, Vue } from "vue-property-decorator";
import { isDevOrLocalEnvironment } from "@/utils/environment";
import { GroupedByProductGroup } from "@/models/queries/ProductOverviewQuery";
import ProductRow from "@/components/products/partials/overview/product-row.vue";

@Component({
  components: { ProductRow }
})
export default class ProductsGroupedByGroup extends Vue {
  @Prop({ required: true })
  private readonly productGroup!: GroupedByProductGroup;
  private isVisible: boolean = false;

  public toggleIsVisible() {
    this.isVisible = !this.isVisible;
  }

  get isDevOrLocalEnv() {
    return isDevOrLocalEnvironment();
  }
}
